import {Select} from "./Select.js";

export class UserJobTitleSelect extends Select {

    template() {
        const {addClassName = ""} = this.$props;
        return `
            <i class="sign-icons-arrow-mini"></i>
              <select id="joinGuestJobTitle" class="join-select-input js-join-jobTitle ${addClassName} " 
                  data-required-yn="Y" 
                  data-empty-msg="${i18next.t(login.jobTitle.required)}" tabindex="3">
                    ${this.getOptionsTemplate()}
              </select>
              <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
              </p>`
    }

    getOptionsDataArr() {
        return [
            {value: "", text: `${i18next.t(login.jobTitle.required)}`},
            {value: "Marketing", text: `${i18next.t(login.jobTitle.job1)}`},
            {value: "IT Operations", text: `${i18next.t(login.jobTitle.job2)}`},
            {value: "Product Management", text: `${i18next.t(login.jobTitle.job3)}`},
            {value: "Human Resources", text: `${i18next.t(login.jobTitle.job4)}`},
            {value: "Sales", text: `${i18next.t(login.jobTitle.job5)}`},
            {value: "Customer Service", text: `${i18next.t(login.jobTitle.job6)}`},
            {value: "Chief Executive Officer", text: `${i18next.t(login.jobTitle.job7)}`},
            {value: "Engineer", text: `${i18next.t(login.jobTitle.job8)}`},
            {value: "Designer", text: `${i18next.t(login.jobTitle.job9)}`},
            {value: "Accounting/Legal", text: `${i18next.t(login.jobTitle.job10)}`},
            {value: "Finance", text: `재무`},
            {value: "Other (GENERAL)", text: `${i18next.t(login.jobTitle.job11)}`},
        ].filter(data => !Often.isGlobal() || data.value !== "Finance"); // 글로벌은 재무 옵션 삭제
    }

    getQuerySelectorOfSelect() {
        return `#joinGuestJobTitle`;
    }

}